<template>
  <v-content>
    <v-overlay v-if="loadingOverlay === true">
      <div>Loading Page...</div>
    </v-overlay>

    <v-container v-if="igProfile !== null">
      <h3 style="text-align:center;">@{{igProfile.profileName}} Candidates</h3>
      <v-card
        class="mx-auto float"
        max-width="344"
        outlined
        v-for="profile in candidates"
        :key="profile._id"
      >
        <v-list-item three-line>
          <v-list-item-content>
            <div class="overline mb-4">@{{profile.profileName}}</div>
            <v-list-item-title class="headline mb-1">{{profile.fullName}}</v-list-item-title>
            <v-list-item-subtitle>{{profile.bio}}</v-list-item-subtitle>
            <v-list-item-subtitle>Followers: {{profile.followerCount}}</v-list-item-subtitle>
          </v-list-item-content>

          <v-list-item-avatar tile size="80" color="grey">
            <v-img :src="profile.profilePic"></v-img>
          </v-list-item-avatar>
        </v-list-item>

        <v-card-actions>
          <v-btn text :href="`https://instagram.com/${profile.profileName}`" target="_blank">Profile</v-btn>
          <v-btn
            text
            @click="updateStatus({ 'profile': `${profile.profileName}`, 'status' : 'archived' })"
          >Skip</v-btn>
          <v-btn
            text
            @click="updateStatus({ 'profile': `${profile.profileName}`, 'status' : 'complete' })"
          >Complete</v-btn>
        </v-card-actions>
      </v-card>
    </v-container>
  </v-content>
</template>
<script>
import firebase from "firebase";
import axios from "axios";
import {
  igProfileReadApi,
  igProfileEngagementCandidateListApi,
  igProfileEngagementCandidateStatusApi
} from "@/config/appSettings";
export default {
  data: () => ({
    loadingOverlay: true,
    igProfile: null,
    candidates: []
  }),
  name: "EngagementCandidates",
  methods: {
    async loadProfile() {
      try {
        let userToken = firebase.auth().currentUser.uid;
        let loadProfileUrl = `${igProfileReadApi}/?usertoken=${userToken}&instagram=${this.$route.params.profileName}`;
        let igProfile = await axios.get(loadProfileUrl);
        if (igProfile.data.success === true) {
          this.igProfile = igProfile.data.result[0];
          this.loadCandidates();
        }
      } catch (err) {
        //console.log("ERROR:", err);
      }
    },
    async loadCandidates() {
      try {
        let userToken = firebase.auth().currentUser.uid;
        let loadEngagementProfileUrl = `${igProfileEngagementCandidateListApi}/?usertoken=${userToken}&instagram=${this.$route.params.profileName}`;
        let engagementProfileResponse = await axios.get(
          loadEngagementProfileUrl
        );
        //console.log("HERE IS THE LIST:", engagementProfileResponse);
        if (engagementProfileResponse.data.success === true) {
          this.candidates = engagementProfileResponse.data.result;
          this.closeLoadingModal();
        }
      } catch (err) {
        //console.log("ERROR:", err);
      }
    },
    async updateStatus(event) {
      //console.log("EVENT:", event);
      this.candidates = this.candidates.filter(x => {
        return x.profileName !== event.profile;
      });
      try {
        let userToken = firebase.auth().currentUser.uid;
        let updateStatus = {};
        updateStatus.candidate = event.profile;
        updateStatus.status = event.status;
        updateStatus.instagram = this.$route.params.profileName;
        updateStatus.usertoken = firebase.auth().currentUser.uid;

        let engagementProfileUpdateResponse = await axios.post(
          igProfileEngagementCandidateStatusApi,
          updateStatus
        );
        //console.log("UPDATE:", engagementProfileUpdateResponse);
      } catch (err) {
        //console.log("ERROR:", err);
      }
    },
    closeLoadingModal() {
      let self = this;

      setTimeout(function() {
        self.loadingOverlay = false;
      }, 100);
    }
  },

  mounted() {
    this.loadProfile();
    this.loadCandidates();
  }
};
</script>

<style scoped>
.float {
}
</style>